export default __webpack_public_path__ + "static/media/cooperate1.a220c6b5.png";